import { memo } from 'react';
import { SidebarIconWrapper } from '@/app/components/navigation/sidebar/sidebar-icon-wrapper';
import { SidebarLabel } from '@/app/components/navigation/sidebar/sidebar-label';
import { SidebarSimpleListItem } from '@/app/components/navigation/sidebar/sidebar-simple-list-item';
import { useLocation } from 'react-router-dom';
import {
  Activity,
  DataBase,
  Chat,
  EventSchedule,
  ToolKit,
} from '@carbon/icons-react';
import { useWorkspace } from '@/workspace';

export const Observability = memo(({ isLoading }: { isLoading?: boolean }) => {
  const location = useLocation();
  const { pathname } = location;
  const workspace = useWorkspace();

  return (
    <li>
      <SidebarSimpleListItem
        active={pathname.endsWith('/logs')}
        navigate="/logs"
        loading={isLoading}
      >
        <SidebarIconWrapper>
          <Activity size={20} />
        </SidebarIconWrapper>
        <SidebarLabel isLoading={isLoading}>LLM logs</SidebarLabel>
      </SidebarSimpleListItem>

      <SidebarSimpleListItem
        active={pathname.includes('/logs/tool')}
        navigate="/logs/tool"
        loading={isLoading}
      >
        <SidebarIconWrapper>
          <ToolKit size={20} />
        </SidebarIconWrapper>
        <SidebarLabel isLoading={isLoading}>Tool logs</SidebarLabel>
      </SidebarSimpleListItem>
      <SidebarSimpleListItem
        active={pathname.includes('/logs/request')}
        navigate="/logs/request"
        loading={isLoading}
      >
        <SidebarIconWrapper>
          <EventSchedule size={20} />
        </SidebarIconWrapper>
        <SidebarLabel isLoading={isLoading}>Request logs</SidebarLabel>
      </SidebarSimpleListItem>
      {workspace.features?.knowledge !== false && (
        <SidebarSimpleListItem
          active={pathname.includes('/logs/knowledge')}
          navigate="/logs/knowledge"
          loading={isLoading}
        >
          <SidebarIconWrapper>
            <DataBase size={20} />
          </SidebarIconWrapper>
          <SidebarLabel isLoading={isLoading}>Knowledge logs</SidebarLabel>
        </SidebarSimpleListItem>
      )}
      <SidebarSimpleListItem
        active={pathname.includes('/logs/conversation')}
        navigate="/logs/conversation"
        loading={isLoading}
      >
        <SidebarIconWrapper>
          <Chat size={20} />
        </SidebarIconWrapper>
        <SidebarLabel isLoading={isLoading}>Conversation logs</SidebarLabel>
      </SidebarSimpleListItem>
    </li>
  );
});
